import { lazyNamed } from 'src/utils/lazyNamed.ts';

const Users = {
  UsersList: lazyNamed(() => import('./containers/UsersList/index.tsx'), 'UsersList'),
  UserForm: lazyNamed(() => import('./containers/UserForm/index.tsx'), 'UserForm'),
};

export default Users;
